export class Role {
    role_name: string;

    constructor(role_name: string) {
        this.role_name = role_name;
    }
}




// WEBPACK FOOTER //
// ./src/app/user/role.ts